// extracted by mini-css-extract-plugin
export default {"text-center":"Typography_text-center__POEwC","text-secondary":"Typography_text-secondary__Q5sus"};